import ChatHeader from './ChatHeader'

export default ChatHeader
